// 引入axios
import axios from 'axios'
import { Message } from 'element-ui';

// 设置请求头可携带cookie
axios.defaults.withCredentials = true;
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.headers['Accept'] = 'application/json;charset=UTF-8';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['Client-Token'] = window.localStorage.getItem("clientToken") || '';
axios.defaults.headers['satoken'] = window.localStorage.getItem("clientToken") || '';

// export const baseUrl = "https://"
export const base = process.env.NODE_ENV == 'development'?'/api':process.env.VUE_APP_BASE_API;
// export const secondBase = 'http://223.223.199.22:21066/api/store'
// export const secondBase = 'https://www.hzzl.net/api/store'
export const secondBase = 'https://www.bjkjb2c.com/api/osms';
// export const secondBase = 'http://103.83.47.198/api/osms';


// axios请求拦截器，增加用户信息请求头
// axios.interceptors.request.use(config => {
//     let clientToken = window.sessionStorage.getItem('clientToken');
//     //增加接口时间戳
//     config.headers.common['clientToken'] = clientToken;
//     return config;
// })
// axios返回拦截器,主要截获全局请求数据
axios.interceptors.response.use(response => {
    if (response.data.code == '401') {
        Message.warning({ title: 'error', message: '登录过期，请重新登录！' });
        window.sessionStorage.clear();
        window.localStorage.clear();
        setTimeout(()=>{
            getSsoAuthUrl({clientLoginUrl: window.location.href}).then(res => {
                window.location.href = res.data.data
            })
        },1500)
        return
    }
    // if (response.data.code == '401') {
    //     Message.warning({ title: 'error', message: '登录过期，请重新登录！' });
    //     window.sessionStorage.clear();
    //     window.localStorage.clear();
    //     setTimeout(()=>{
    //         getSsoAuthUrl({clientLoginUrl: window.location.href}).then(res => {
    //             window.location.href = res.data.data
    //         })
    //     },1500)
    //     return
    // }
    if (response.data.code == '8888') {
        Message.warning({ title: 'error', message: '重复登录！' });
        window.sessionStorage.clear();
        setTimeout(()=>{window.location.href = base + "/gatewayWebsiteServer/login/casLogin";},1500)
        return
    }
    if(typeof(response.data) == 'string'){
        if(response.data.indexOf('DOCTYPE') >= 1){
            window.sessionStorage.clear();
            window.location.href = base + "/gatewayWebsiteServer/login/casLogin"
        }
    }
    if (response.data.code === 9999) {
        return Message.warning({ title: 'error', message: '系统错误！' });
    }
    if (response.status === 200) {
        return response;
    }
}, error => {
    console.log(error)
    if (error.response.status === 500) {
        Message.warning({ title: 'error', message: '系统错误！' });
    }
    if (error.response.status === 401) {
        window.sessionStorage.clear();
        window.location.href = base + "/gatewayWebsiteServer/login/casLogin"
    }
    if (error.response.status === 302) {
        window.sessionStorage.clear();
        window.location.href = base + "/gatewayWebsiteServer/login/casLogin"
    }
    return Promise.reject(error.response);
});

// 发送手机验证码
export const sendSmsToService = (params) => {
    return axios.get(`${base}/gatewayWebsiteServer/sms/msg/sendSmsToService`, {params:params}).then(res => res).catch(err => err);
};

// 验证手机验证码
export const checkCode = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/sms/msg/checkCode`, params).then(res => res).catch(err => err);
};

//增加请求头
export const addRequestHeader = clientToken => {
    //增加接口时间戳
    axios.defaults.headers['clientToken'] = clientToken;
}

//税则查询
export const criteriaSearch = params => {
    return axios
        // .post(`https://edu.ethro.net:9566/service/precedent/TariffController/criteriaSearch`, params)
        .post(`${base}/gatewayWebsiteServer/allWebsite/queryTariff`, params)
        .then(res => res.data)
}

//税则详情
export const viewDetails = params => {
    return axios
        // .post(`https://edu.ethro.net:9566/precedent/TariffController/viewDetails`, params)
        .post(`${base}/gatewayWebsiteServer/allWebsite/queryTariffDetail`, params)
        .then(res => res.data)
}

// 获取所有系统信息
export const queryAllWebServer = params => {
    return axios
        .post(`${base}/gatewayWebsiteServer/queryAllWebServer`, params)
        .then(res => res.data)
}

// 获取企业备案记录
export const getEnterprisesRecord = params => {
    return axios
        .post(`${secondBase}/enterprise/getEnterprisesRecord`, params)
        .then(res => res.data)
}

// 推送企业备案信息
export const receptionEnterprises = params => {
    return axios
        .post(`${secondBase}/enterprise/receptionEnterprises`, params)
        .then(res => res.data)
}

// 编辑企业备案信息
export const updateEnterprises = params => {
    return axios
        .post(`${secondBase}/enterprise/updateEnterprises`, params)
        .then(res => res.data)
}

// 获取cookies
export const getCookies = params => {
    return axios
        .post(`${base}/gatewayWebsiteServer/login/getCookies`, params)
        .then(res => res.data)
}

// 获取LoginInfo
export const getLoginInfo = params => {
    return axios
        .post(`${base}/gatewayWebsiteServer/login/getLoginInfo`, params)
        .then(res => res.data)
}

// 用户名登录
export const login = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/login/pcUserLogin`, params).then(res => res).catch(err => err);
};

// 个人中心列表
export const userList = params => {
    return axios.post(`${base}/gatewayWebsiteServer/personal/userList`, params).then(res => res.data)
}

// 修改密码
export const updatePassword = params => {
    return axios.post(`${base}/gatewayWebsiteServer/personal/updatePassword`, params).then(res => res.data)
}

// 更换手机
export const updatePhone = params => {
    return axios.post(`${base}/gatewayWebsiteServer/personal/updatePhone`, params).then(res => res.data)
}

// 修改邮箱
export const updateUserMail = params => {
    return axios.post(`${base}/gatewayWebsiteServer/personal/updateUserMail`, params).then(res => res.data)
}

//企业展厅查询-首页
export const getExhibitFirst = params => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/queryShow`, params).then(res => res.data)
}

//企业展厅查询
export const getExhibit = params => {
    return axios.post(`${base}/gatewayWebsiteServer/show/queryShow`, params).then(res => res.data)
}

//企业展厅添加
export const addExhibit = params => {
    return axios.post(`${base}/gatewayWebsiteServer/show/addShow`, params).then(res => res.data)
}

//企业展厅删除
export const delExhibit = params => {
    return axios.post(`${base}/gatewayWebsiteServer/show/deleteShow`, params).then(res => res.data)
}

// 企业展厅- 编辑回显
export const ExhibitDetailShow = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/detailShow`, params).then(res => res).catch(err => err);
};

// 企业展厅- 编辑
export const ExhibitEditShow = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/show/editShow`, params).then(res => res).catch(err => err);
};

// 企业展厅- 撤销
export const ExhibitUndoShow = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/show/undoShow`, params).then(res => res).catch(err => err);
};

// 企业展厅- 发布
export const ExhibitPublishShow = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/show/publishShow`, params).then(res => res).catch(err => err);
};

// 企业资讯- 新建
export const informationInsert = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/content/insertContent`, params).then(res => res).catch(err => err);
};

// 企业资讯 - 首页 - 查询
export const informationQuery = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/queryCompanyInfoList`, params).then(res => res).catch(err => err);
};

// 企业资讯- 查询
export const informationQuerySenond = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/content/queryCompanyInfoList`, params).then(res => res).catch(err => err);
};

// 企业资讯- 删除
export const informationDel = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/content/deleteContent`, params).then(res => res).catch(err => err);
};

// 企业资讯- 撤销/发布
export const informationInfo = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/content/handleContentInfo`, params).then(res => res).catch(err => err);
};

// 企业资讯- 回显
export const queryContentInfo = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/queryContentInfo`, params).then(res => res).catch(err => err);
};

// 企业资讯- 编辑
export const updateContent = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/content/updateContent`, params).then(res => res).catch(err => err);
};



// 注册
export const register = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/login/userRegister`, params).then(res => res).catch(err => err);
};

// 解封
export const useunFreeze = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/login/unFreeze`, params).then(res => res).catch(err => err);
};

// 找回密码
export const findPassword = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/login/findPassword`, params).then(res => res).catch(err => err);
};

// 政企交流-查询
export const WebsiteServerCheck = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/companyMsgBoard/selectAllCompanyMsgBoard`, params).then(res => res).catch(err => err);
};

// 政企交流-新建
export const WebsiteServerAdd = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/companyMsgBoard/addCompanyMsgBoard`, params).then(res => res).catch(err => err);
};

// 政企交流-查看回复
export const WebsiteServerReply = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/companyMsgBoard/selectReplyContentById`, params).then(res => res).catch(err => err);
};

// 政企交流-删除回复
export const WebsiteServerDelete = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/companyMsgBoard/updateCompanyMsgBoardById`, params).then(res => res).catch(err => err);
};

// 政企交流-回复内容
export const WebsiteServerHf = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/companyMsgBoard/replyCompanyMsgBoardById`, params).then(res => res).catch(err => err);
};

// 意见反馈-新增建议
export const insertComplain = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/complainInfo/insertComplain`, params).then(res => res).catch(err => err);
};

// 企业管理-账号管理 - 查询
export const queryUserList = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/user/queryUserList`, params).then(res => res).catch(err => err);
};

// 官网政策、行业、通知 - 查询列表
export const queryContentList = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/queryContentList`, params).then(res => res).catch(err => err);
};

// 企业管理-账号管理 - 新建
export const insertUser = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/user/insertUser`, params).then(res => res).catch(err => err);
};

// 企业管理-账号管理 - 编辑
export const updateUser = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/user/updateUser`, params).then(res => res).catch(err => err);
};

// 企业管理-账号管理 - 删除
export const deleteUser = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/user/deleteUser`, params).then(res => res).catch(err => err);
};

// 智能客服-常用语查询
export const getCommonLanguageById = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/getCommonLanguageById`, params).then(res => res).catch(err => err);
};

// 智能客服-关键字获取问题库
export const getKnowledgeRequestionByKeyword = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/requestion/getKnowledgeRequestionByKeyword`, params).then(res => res).catch(err => err);
};

// 智能客服-查询单条问题库
export const getKnowledgeRequestionById = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/requestion/getKnowledgeRequestionById`, params).then(res => res).catch(err => err);
};

// pc端菜单栏
export const getqueryMenu = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/queryMenu`, params).then(res => res).catch(err => err);
};

// 指定企业下的企业资讯列表查询
export const queryCompanyInfoList = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/queryCompanyInfoList`, params).then(res => res).catch(err => err);
};


// 指定企业下的企业资讯列表查询
export const queryCompanyInfoListSecond = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/queryCompanyInfoList`, params).then(res => res).catch(err => err);
};

// 增加点击次数
export const addContentHit = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/addContentHit`, params).then(res => res).catch(err => err);
};

// 海关参数查询
export const queryCustomsParameter = (params) => {
    return axios.get(`${base}/gatewayWebsiteServer/allWebsite/queryCustomsParameter`, {params:params}).then(res => res).catch(err => err);
};

// 获取栏目参数
export const queryCategoryByCode = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/queryCategoryByCode`, params).then(res => res).catch(err => err);
};

// 出口运单查询
export const queryExport = (params) => {
    return axios.get(`${base}/gatewayWebsiteServer/allWebsite/queryExport`, {params:params}).then(res => res).catch(err => err);
};

// 进口运单查询
export const queryImport = (params) => {
    return axios.get(`${base}/gatewayWebsiteServer/allWebsite/queryImport`, {params:params}).then(res => res).catch(err => err);
};

// 消费税费查询
export const queryTaxByUserInfo = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/queryTaxByUserInfo`, params).then(res => res).catch(err => err);
};

// 字典
export const getDictionaryInfo = (params) => {
    return axios.get(`${base}/gatewayWebsiteServer/allWebsite/getDictionaryInfo`, {params:params}).then(res => res).catch(err => err);
};

// 302重定向获取用户数据
export const getIcCardLoginInfo = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/login/getIcCardLoginInfo`, params).then(res => res).catch(err => err);
};

// 全站搜索
export const queryAllContent = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/allWebsite/queryAllContent`, params).then(res => res).catch(err => err);
};

// 个人中心升级企业用户 - 查看详情
export const showroomDetail = (params) => {
    return axios.get(`${base}/gatewayWebsiteServer/showroom/getDetails`, {params:params}).then(res => res).catch(err => err);
};

// 个人中心升级企业用户 - 升级展厅企业用户
export const inserEnterprise = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/inserEnterprise`, params).then(res => res).catch(err => err);
};

// 个人中心升级企业用户 - 修改升级展厅企业用户
export const modifyEnterprise = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/modifyEnterprise`, params).then(res => res).catch(err => err);
};

// 获取单点登录地址
export const getSsoAuthUrl = (params) => {
    return axios.get(`${base}/gatewayWebsiteServer/sso/getSsoAuthUrl`, {params:params}).then(res => res).catch(err => err);
};

// 获取单点登录地址
export const doLoginByTicket = (params) => {
    return axios.get(`${base}/gatewayWebsiteServer/sso/doLoginByTicket`, {params:params}).then(res => res).catch(err => err);
};

// 获取单点登录地址
export const doLogout = (params) => {
    return axios.get(`${base}/gatewayWebsiteServer/sso/logout`, {params:params}).then(res => res).catch(err => err);
};

// 记录日志
export const visitLog = (params) => {
    return axios.post(`${base}/gatewayWebsiteServer/api/visitLog`, params).then(res => res).catch(err => err);
};
